// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-histogram{height:6rem;background-color:#e4e4ee}@media only screen and (max-width: 1023px){.bw-histogram{height:4.5rem}}.bw-items-wrapper{scroll-behavior:smooth;margin:0 1rem}@media only screen and (max-width: 1023px){.bw-items-wrapper{overflow-x:scroll}}.bw-items-container{height:5.4rem;gap:.4rem}@media only screen and (max-width: 1023px){.bw-items-container{height:4rem}}.bw-scroll-positions{top:35%;transform:translateY(-50%);z-index:1;border:2px solid #0c0243;padding:.25rem}@media only screen and (min-width: 1024px){.bw-scroll-positions{display:none !important}}.bw-left{left:.4rem}.bw-right{right:.4rem}@media only screen and (max-width: 1023px){.bw-sticky{position:sticky;top:4.55rem;z-index:2}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"histogram": "bw-histogram",
	"items-wrapper": "bw-items-wrapper",
	"items-container": "bw-items-container",
	"scroll-positions": "bw-scroll-positions",
	"left": "bw-left",
	"right": "bw-right",
	"sticky": "bw-sticky"
};
module.exports = ___CSS_LOADER_EXPORT___;
